const ImageCard = ({ classnames, userImage, children }) => {
    return (
        <div
            className={classnames}
            style={{ backgroundImage: `url(${userImage})` }}
        >
            {children}
        </div>
    );
};
export default ImageCard;
